// extracted by mini-css-extract-plugin
export default {"link":"back-btn_link__QB1G7","arrow":"back-btn_arrow__UnHYM","title":"back-btn_title__wMymm"};